export default __webpack_public_path__ + "images/C2.691b98f.png";